/*
 Facade in front of Algonomy's RR JSON API. Documentation here:
 https://help.richrelevance.com/Integration_Guide/0010_JSON_Integration%3A_Core_Integration/0010_Integration%3A_JSON_Integration_Overview
 */

export var R3_COMMON = function R3_COMMON() {
  if (!window.R3_COMMON) {
    window.R3_COMMON = new window.r3_common();
  }
  return window.R3_COMMON;
};
export var R3_CATEGORY = function R3_CATEGORY() {
  if (!window.R3_CATEGORY) {
    window.R3_CATEGORY = new window.r3_category();
  }
  return window.R3_CATEGORY;
};
export var R3_ADDTOCART = function R3_ADDTOCART() {
  if (!window.R3_ADDTOCART) {
    window.R3_ADDTOCART = new window.r3_addtocart();
  }
  return window.R3_ADDTOCART;
};
export var R3_HOME = function R3_HOME() {
  if (!window.R3_HOME) {
    window.R3_HOME = new window.r3_home();
  }
  return window.R3_HOME;
};
export var R3_BRAND = function R3_BRAND() {
  if (!window.R3_BRAND) {
    window.R3_BRAND = new window.r3_brand();
  }
  return window.R3_BRAND;
};
export var R3_SEARCH = function R3_SEARCH() {
  if (!window.R3_SEARCH) {
    window.R3_SEARCH = new window.r3_search();
  }
  return window.R3_SEARCH;
};
export var R3_ITEM = function R3_ITEM() {
  if (!window.R3_ITEM) {
    window.R3_ITEM = new window.r3_item();
  }
  return window.R3_ITEM;
};
export var R3_GENERIC = function R3_GENERIC() {
  if (!window.R3_GENERIC) {
    window.R3_GENERIC = new window.r3_generic();
  }
  return window.R3_GENERIC;
};
export var R3_CART = function R3_CART() {
  if (!window.R3_CART) {
    window.R3_CART = new window.r3_cart();
  }
  return window.R3_CART;
};
export var R3_PURCHASED = function R3_PURCHASED() {
  if (!window.R3_PURCHASED) {
    window.R3_PURCHASED = new window.r3_purchased();
  }
  return window.R3_PURCHASED;
};
export var R3_ERROR = function R3_ERROR() {
  if (!window.R3_ERROR) {
    window.R3_ERROR = new window.r3_error();
  }
  return window.R3_ERROR;
};